import React from 'react';
export var LocaleContext = /*#__PURE__*/React.createContext({
  selectPromptMessage: 'Selecione',
  selectAllMessage: 'Selecionar todos',
  Wizard: {
    stepText: 'Step',
    backText: 'Voltar',
    nextText: 'AVANÇAR',
    finishText: 'FINALIZAR'
  },
  Table: {
    labelRowsPerPage: 'Linhas por página:',
    labelDisplayedRows: function labelDisplayedRows(_ref) {
      var from = _ref.from,
          to = _ref.to,
          count = _ref.count;
      return "".concat(from, "-").concat(to, " de ").concat(count);
    },
    tooltipAdvancedFilter: 'Filtros Avançados',
    applyFiltersLabel: 'Aplicar Filtros',
    selectedFiltersLabel: 'Filtros Selecionados',
    emptyStateTitle: 'Nada por aqui',
    emptyStateMessage: 'Não existem dados para exibição.'
  },
  Picker: {
    todayLabel: 'Hoje',
    okLabel: 'Ok',
    cancelLabel: 'Cancelar',
    clearLabel: 'Limpar'
  },
  AppBar: {
    filterLabel: 'Filtro',
    closeSearch: 'Fechar Busca',
    openSearch: 'Abrir Busca',
    openMenu: 'Abrir Menu'
  }
});